import { render, staticRenderFns } from "./AfterSubmit.vue?vue&type=template&id=4bf08fb2&"
import script from "./AfterSubmit.vue?vue&type=script&lang=js&"
export * from "./AfterSubmit.vue?vue&type=script&lang=js&"
import style0 from "./AfterSubmit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports